<template>
    <GenericIFrame :dashboardId="this.$store.getters.getCurrentDashboardId" />
</template>

<script>
import GenericIFrame from '@/components/GenericIFrame';
import { mapGetters } from 'vuex';

export default {
    components: {
        GenericIFrame
    },
    watch: {
        async '$store.getters.getCurrentClientId'() {
            if (this.$store.getters.getCurrentClientId) {
                await this.getFrame();
            }
        }
    },
    computed: {
        ...mapGetters(['getBookmarkedServices', 'getServices', 'getCurrentClientId'])
    },
    methods: {
        async getFrame() {
            let clientId = this.$store.getters.getCurrentClientId;
            var path = window.location.pathname.split('/');
            let indexOfIframeInPath = path.indexOf('IFRAME');
            let serviceNumber = path[indexOfIframeInPath + 1];
            let instance = path[indexOfIframeInPath + 2];
            let autorizedInstances = this.getServices.find(item => item.serviceNumber === serviceNumber);
            let instances =
                autorizedInstances?.instance && autorizedInstances.instance[clientId]
                    ? autorizedInstances.instance[clientId]
                    : null;
            if (instances && instances.includes(Number(instance))) {
                this.$store.commit('setIframeServiceNumber', serviceNumber);
                this.$store.commit('setAutorizedIframeInstances', instances);
                this.$store.commit('setDashboardId', instance);
            } else {
                this.$store.commit('displayErrors', {
                    errno: 3402
                });
            }
        }
    },
    async mounted() {
        //reset default error state
        this.$store.commit('closeErrors');

        if (this.autorizedIframeInstance.length && this.autorizedIframeInstance.length === 1) {
            this.selectDashboard(this.autorizedIframeInstance[0]);
        }
        if (this.$store.getters.getCurrentClientId) {
            await this.getFrame();
        }
    }
};
</script>
